import React from "react";
import { appHelpers } from "../../_helpers";
import PageEmptyContent from "../utils/page.empty-content";
import ServerPaginatedTable from "../utils/pagination.server";
import { Badge } from 'reactstrap';
import IconEye from 'react-icons/lib/md/remove-red-eye';
import ToolTipItem from "../utils/tooltip";
import ViewIcon from 'react-icons/lib/md/remove-red-eye';


const ManifestTableStructure = ({ data, pageIndex, toggleModal,toggleErrorModal }) => {
    return (data.length === 0) ?
        (<PageEmptyContent message='No record match your search!' />) :

        (
            <div className="view">
                <table className="table table-striped table-hover fixed">
                    <thead>
                        <tr>
                            {/* <th style={{ width: "72px" }}>
                                <span>S/N</span>
                            </th> */}
                            <th style={{ width: "32%" }}>
                                <span>User</span>
                            </th>
                            <th>
                                <span>Airline</span>
                            </th>
                            <th>
                                <span>Created date</span>
                            </th>
                            <th>
                                <span>Action</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((record, i) =>
                            <tr key={i}>
                                {/* <td className="text-capitalize">{`${pageIndex + i + 1}`}</td> */}
                                <td>{record.UserName}</td>
                                <td>{record.AirlineName}</td>
                                <td className="text-capitalize">{`${appHelpers.formatDate(record.CreatedDate)}`}</td>
                                {record.Summary === null && record.ManifestSummary === null && (
                                    //     <td>  
                                    //     <span className="pointer" 
                                    //     onClick={(e) => toggleModal(e,record)}
                                    //     >
                                    //         <ToolTipItem key={'viewRecord'} title={<ViewIcon size="18" color="#3da7e2" />} content='View' id={'viewRecord'} />
                                    //     </span>

                                    // </td>
                                    <td>
                                        <span>
                                            <Badge color="info">&nbsp;Pending&nbsp;</Badge>
                                        </span>
                                    </td>
                                )}
                                {record.ManifestSummary !== null && record.Summary !== null && (
                                    <td>
                                        <span className="pointer"
                                            onClick={(e) => toggleModal(e, record)}
                                        >
                                            <ToolTipItem key={'viewRecord'} title={<ViewIcon size="18" color="#3da7e2" />} content='View' id={'viewRecord'} />
                                        </span>

                                    </td>
                                )}
                                {record.ManifestSummary === null && typeof record.Summary === "string" && (
                                //      <span className="pointer"
                                //      onClick={(e) => toggleErrorModal(e, record)}
                                //  >
                                //      <ToolTipItem key={'viewRecord'} title={<ViewIcon size="18" color="#3da7e2" />} content='View Error' id={'viewRecord'} />
                                //  </span>
                                     <span>
                                     <Badge color='warning'>{record.Summary}</Badge>
                                 </span>
                                )}

                                
                            </tr>)}
                    </tbody>
                </table>
            </div>
        )
};
class UploadManifestRecords extends React.Component {
    render() {
        let { interpretAirline, interpretAirport, interpretUserId, currentPage, pageDataCallback, pageSize, totalCount, records, handleView, toggleModal, toggleErrorModal } = this.props;
        let pageIndex = (currentPage - 1) * pageSize;

        return (
            <ServerPaginatedTable currentPage={currentPage} fetchMore={pageDataCallback} target={<ManifestTableStructure data={records} interpretAirport={interpretAirport} interpretAirline={interpretAirline} interpretUserId={interpretUserId} pageIndex={pageIndex} handleView={handleView} toggleModal={toggleModal} toggleErrorModal={toggleErrorModal} />}
                pageSize={pageSize} totalCount={totalCount} />
        )
    }
}
export default UploadManifestRecords;



// WEBPACK FOOTER //
// ./src/views/uploadManifest/manifest-table.js